import Card from "antd/es/card/Card";
import { isEmpty } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MdAdd } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Header from "shared/components/Header";
import Search from "shared/components/Input";
import Pagination from "shared/components/Pagination";
import Spin from "shared/components/Spin";
import { useQuery } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import { SCREENS } from "utils/constants";
import { GET_EMAIL_TEMPLATES } from "utils/api/graphql/queries/emailTemplate";
import View from "./View";

const List = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.EMAIL_TEMPLATE);
  const LIST = t("LIST", { returnObjects: true });
  const [pagination, setPagination] = useState({ skip: 0, take: 10 });
  const [search, setSearch] = useState("");
  const filter = isEmpty(search)
    ? undefined
    : { OR: [{ label: `%${search}%` }] };
  const navigate = useNavigate();

  const { data, loading } = useQuery(GET_EMAIL_TEMPLATES, {
    variables: {
      where: filter,
      ...pagination,
      orderBy: [{ createdDate: "DESC" }],
    },
  });

  const buttons = [
    {
      icon: <MdAdd size={24} />,
      text: LIST.HEADER?.SAVE,
      onClick: () =>
        navigate(SCREENS.PRIVATE.ADMIN.EMAIL_TEMPLATES.CREATE.path),
    },
  ];

  return (
    <>
      <Header title={LIST.HEADER?.TITLE} actions={buttons} />
      <Card type="simple">
        <div className="m-bottom-20 grid--4">
          <Search
            placeholder={LIST.SEARCH}
            type="search"
            onChange={({ target: { value } }) => {
              setPagination((prev) => ({ ...prev, skip: 0 }));
              setSearch(value);
            }}
          />
        </div>
        {loading ? (
          <Spin />
        ) : (
          <View
            data={data?.emailTemplates?.data || []}
            count={data?.emailTemplates?.count || 0}
            setValues={setPagination}
            skip={pagination.skip}
          />
        )}
      </Card>
    </>
  );
};

export default List;
